/** Matches `--breakpoint-lg` in `assets/css/theme.css` (Tailwind `lg`). */
export const BREAKPOINT_LG_PX = 976
export const BREAKPOINT_LG_MIN_QUERY = `(min-width: ${BREAKPOINT_LG_PX}px)` as const
